import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import searchService from './searchService'

const errorMessage = (error) => {
  return (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
}

const initialState = {
  searchValues: [],
  isSearchError: false,
  isSearchSuccess: false,
  isSearchLoading: false,
  searchMessage: '',
  nextPageR: 0,
  hasNextPageR: false,
}

// search
export const search = createAsyncThunk(
  'search/search',
  async (searchData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await searchService.search(searchData, token)
    } catch (error) {
      const message = errorMessage(error)
      return thunkAPI.rejectWithValue(message)
    }
  }
)




export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    searchReset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(search.pending, (state) => {
        state.isSearchLoading = true
      })
      .addCase(search.fulfilled, (state, action) => {
        state.isSearchLoading = false
        state.isSearchSuccess = true
        state.searchValues = action.payload
      })
      .addCase(search.rejected, (state, action) => {
        state.isSearchLoading = false
        state.isSearchError = true
        state.searchMessage = action.payload
      })
      //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

  },
})

export const { searchReset } = searchSlice.actions
export default searchSlice.reducer
